import React from 'react';

function formatTime(isoString) {
  if (!isoString) return '';
  const d = new Date(isoString);
  const now = new Date();
  const isToday =
    d.getDate() === now.getDate() &&
    d.getMonth() === now.getMonth() &&
    d.getFullYear() === now.getFullYear();
  if (isToday) {
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }
  return `${d.getMonth() + 1}/${d.getDate()}`;
}

export default function ConversationTile({ title, lastMessage, lastTime, online, onTap }) {
  return (
    <div className="conversation-tile" onClick={onTap}>
      <div className="conv-avatar">
        <div className="avatar-circle">
          {title ? title[0].toUpperCase() : '?'}
        </div>
        {online && <div className="online-dot" />}
      </div>
      <div className="conv-info">
        <div className="conv-header">
          <span className="conv-name">{title || 'Unknown'}</span>
          <span className="conv-time">{formatTime(lastTime)}</span>
        </div>
        <div className="conv-last-msg">
          {lastMessage ? lastMessage : 'No messages yet'}
        </div>
      </div>
    </div>
  );
}
